import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {

  private url = environment.urlApi;
  private propiedades: any[];

  constructor(private http: HttpClient) {
    console.log('Servicio listo');
  }

  getApi(query: string) {
    const url = `${this.url}/${query}`;
    return this.http.get(url);
  }

  deleteApi(query: string) {
    const url = `${this.url}/${query}`;
    return this.http.delete(url);
  }

  postApi(query: string, objeto: any) {
    const url = `${this.url}/${query}`;
    return this.http.post(url, objeto);
  }

  putApi(query: string, objeto: any) {
    const url = `${this.url}/${query}`;
    return this.http.put(url, objeto);
  }

  getPropiedades(tOp, tpro, ciu, bar, dorm, coch, pat, apCredito, from, to) {
    return this.getApi(
      `Propiedades/list/${tOp}/${tpro}/${ciu}/${bar}/${dorm}/${coch}/${pat}/${apCredito}/${from}/${to}`
    );
  }

  /** 🔹 Ahora acepta direccion como último parámetro */
  getAdminListProp(tOp, tpro, ciu, bar, dorm, coch, pat, state, direccion: string = '', from, to) {
    // encodeURIComponent para evitar problemas con espacios en la URL
    const dirParam = direccion && direccion.trim() !== '' ? encodeURIComponent(direccion) : 'ALL';
    return this.getApi(
      `Propiedades/adminList/${tOp}/${tpro}/${ciu}/${bar}/${dorm}/${dirParam}/${coch}/${pat}/${state}/${from}/${to}`
    );
  }

  getpropiedadesBanner() {
    return this.getApi(`Propiedades/banner`);
  }

  getpropiedad(id: number) {
    return this.getApi(`Propiedades/${id}`);
  }

  deletePropiedad(id: number) {
    return this.deleteApi(`Propiedades/${id}`);
  }

  postPropiedad(propiedad: any) {
    return this.postApi(`Propiedades/`, propiedad);
  }

  putPropiedad(id: string, propiedad: any) {
    return this.putApi(`Propiedades/${id}`, propiedad);
  }

  SetEstado(id: number, propiedad: any) {
    return this.putApi(`Propiedades/SetEstado/${id}`, propiedad);
  }
  generarDescripcion(data: any) {
  return this.postApi('Propiedades/generar-descripcion', data);
}

}
